module.exports = __webpack_public_path__ + "media/photo.1fb730b6.mp3";